require(['jquery', 'js/glider-min'], function ($) {
const cardArgumentSliders = document.querySelectorAll(".js-card-argument-slider");
if (cardArgumentSliders) {
	cardArgumentSliders.forEach(cardArgumentSlider => {
		let slider = cardArgumentSlider.querySelector('.js-card-argument-slider__cards'),
			slidesToShow = 3,
			sliderPrev = cardArgumentSlider.querySelector('.js-card-argument-slider-prev'),
			sliderNext = cardArgumentSlider.querySelector('.js-card-argument-slider-next'),
			bullets = cardArgumentSlider.querySelector('.js-card-argument-slider-bullets');

		new Glider(slider, {
			dots: bullets,
			scrollLock: true,
			draggable: true,
			arrows: {
				prev: sliderPrev,
				next: sliderNext
			},
			responsive: [
				{
					breakpoint: 0,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						itemWidth: 'auto'
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2.5,
						slidesToScroll: 2.5,
						itemWidth: 'auto'
					}
				},
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: slidesToShow,
						slidesToScroll: 1,
						itemWidth: 'auto'
					}
				},
			]
		});
	})
}});
